import '../themes/footer.scss';

import React from 'react';

import { Links } from '../constants';
import logoLightFull from '../images/logos/logoLightFull.svg';

const linkedin = require('../images/linkedin_icon.png');
const facebook = require('../images/facebook_icon.png');
const instagram = require('../images/instagram_icon.png');

const Footer = () => (
  <div className="background">
    <div className="link_box">
      <div className="logo_container">
        <img src={logoLightFull} style={{ width: 126 }} alt="logo_light_full" />
      </div>

      <div className="link_content_container">
        <div className="link_container">
          <a
            href={Links.temporaryStaffing}
            target="_blank"
            rel="noopener noreferrer"
          >
            Dental Offices

          </a>
          <a
            href={Links.home}
            target="_blank"
            rel="noopener noreferrer"
          >
            How it works

          </a>
          <a
            href={Links.dentistsSideFaqs}
            target="_blank"
            rel="noopener noreferrer"
          >
            FAQs

          </a>
        </div>
        <div className="link_container">
          <a
            href={Links.about}
            target="_blank"
            rel="noopener noreferrer"
          >
            About

          </a>
          {/* <a
            href={Links.getHelp}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Help

          </a> */}
          <a
            href={Links.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          <a
            href={Links.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy

          </a>
        </div>
      </div>
      <div style={{ width: '5%', margin: 0 }} />
    </div>
    <div className="line" />
    <div className="copy_and_icons_container">
      <div>
        <p className="temp-mee-inc">
          ©
          {new Date().getFullYear()}
          {' '}
          GoTu, Inc. - All Right Reserved
        </p>
      </div>
      <div className="icon_box">
        <a
          href="https://www.linkedin.com/company/tempmee"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={linkedin} alt="linkedin" style={{ maxWidth: '40px', height: '40px' }} />
        </a>
        <a
          href="https://www.facebook.com/tempmeeapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={facebook} alt="facebook" style={{ maxWidth: '40px', height: '40px' }} />
        </a>
        <a
          href="https://www.instagram.com/tempmee/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={instagram} alt="instagram" style={{ maxWidth: '40px', height: '40px' }} />
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
